export const DriverRatingsEndpoints = {
  SEARCH_DRIVER_RATINGS: '/api/admin/driver-ratings',
  GET_DRIVER_RATINGS: (source: string, driverId: string) =>
    `/api/admin/driver-ratings/${encodeURIComponent(source)}/${encodeURIComponent(driverId)}`,
};
